/**
 * Menu divider component.
 *
 * A horizontal separator line between menu items.
 */

import * as stylex from "@stylexjs/stylex";

import { styles } from "./menu-styles.stylex";

export function MenuDivider() {
  return <div {...stylex.props(styles.divider)} />;
}
